import React from 'react';
import TextBlinkCustom from '../../common/text-blink-custom';
import { formatTextFloat, formatPrice } from '../../helpers/Text';
import { getDataFollowKeyByDot } from '../../helpers/Common';
import { getColorPrice } from '../../helpers/Color';
import PriceInfoCommon from '../../common/index-summary/PriceInfo';
import Const from '../../common/Const';
import { isTicker } from '../../helpers/Common';

class PriceInfo extends React.Component {
  getDataByTypeSearch = (priceParam, referencePriceParam) => {
    const { priceInfo } = this.props;
    let price = formatTextFloat(priceParam);
    let referencePrice = formatTextFloat(referencePriceParam);
    if (isTicker(priceInfo)) {
      price = formatPrice(priceParam);
      referencePrice = formatPrice(referencePriceParam);
    }
    return [price, referencePrice];
  };

  getChangeByTypeSearch = () => {
    const { priceInfo } = this.props;
    let change = formatTextFloat(
      getDataFollowKeyByDot(priceInfo, Const.indexData.VALUE_CHANGE),
    );
    if (isTicker(priceInfo)) {
      change = formatTextFloat(
        formatPrice(
          getDataFollowKeyByDot(priceInfo, Const.indexData.VALUE_CHANGE),
        ),
      );
    }
    return change;
  };

  render() {
    const { priceInfo } = this.props;

    const price = getDataFollowKeyByDot(priceInfo, Const.indexData.VALUE);
    const referencePrice = getDataFollowKeyByDot(
      priceInfo,
      Const.indexData.REFERENCE_PRICE,
    );
    const ceilingPrice = getDataFollowKeyByDot(
      priceInfo,
      Const.indexData.CEILING_PRICE,
    );
    const floorPrice = getDataFollowKeyByDot(
      priceInfo,
      Const.indexData.FLOOR_PRICE,
    );
    const dataFormat = this.getDataByTypeSearch(price, referencePrice);

    return (
      <div className="left-info-widget__metas">
        <TextBlinkCustom data={priceInfo} compareKey="tradingDate">
          <PriceInfoCommon
            price={formatTextFloat(dataFormat[0])}
            referencePrice={formatTextFloat(dataFormat[1])}
            change={this.getChangeByTypeSearch()}
            percentChange={formatTextFloat(
              getDataFollowKeyByDot(
                priceInfo,
                Const.indexData.PERCENT_VALUE_CHANGE,
              ) * 100,
            )}
            classNameColor={getColorPrice(
              price,
              referencePrice,
              ceilingPrice,
              floorPrice,
            )}
          />
        </TextBlinkCustom>
      </div>
    );
  }
}

export default PriceInfo;
